import React from 'react';

import { SiteFooter } from '../organisms/site-footer';
import { SiteNav } from '../organisms/site-nav';
import { PageTemplate } from './page-template';

export interface Props {
  children: React.ReactNode;
}

export const FallbackPageTemplate: React.FC<Props> = ({ children }) => {
  return (
    <PageTemplate>
      <SiteNav showCart={false} shopLinkActive />
      <div className="min-h-screen-minus-nav">{children}</div>
      <SiteFooter />
    </PageTemplate>
  );
};
